import React from 'react';
import {Link} from "react-router-dom";

import AdminLayout from 'Pages/Admin/AdminLayout';

import {PrimaryButton, SecondaryButton} from 'Components/Button';
import {FormHandler, Input, Checkbox, Select, Toggle} from 'Components/Form';
import {Alert, Loading} from 'Components/Partials';

import AdminExhibitorsApi from 'Services/Api/Admin/Exhibitors';

class ExhibitorsStore extends React.Component {

    /**
     * @var success
     * @type {string}
     */
    success = 'Exhibitor ' + (this.props.match?.params?.exhibitor ? 'updated' : 'created') + ' successfully';

    /**
     * @var state
     * @type {{exhibitor_id: string}}
     */
    state = {
        exhibitor_id: this.props.match?.params?.exhibitor ?? '',
    };

    /**
     * @method componentDidMount
     */
    componentDidMount() {
        if (this.state.exhibitor_id) {
            this.loadExhibitor();
        } else {
            this.props.setInitialValues({
                active: true,
                supported_languages: Object.keys(window.base.languages),
                name: '',
                zone: '',
                email: '',
                telephone: '',
                website: '',
                linkedin: '',
                contact_name: '',
                download_blurb: '',
            });
        }
    }

    /**
     * @method loadExhibitor
     * @param {int} page
     */
    loadExhibitor = async (page = 1) => {
        const {exhibitor_id} = this.state;

        const response = await AdminExhibitorsApi.get(exhibitor_id);

        this.props.setForm({
            active: response.data.data.active,
            supported_languages: response.data.data.supported_languages,
            name: response.data.data.name,
            zone: response.data.data.zone,
            email: response.data.data.email,
            telephone: response.data.data.telephone,
            website: response.data.data.website,
            linkedin: response.data.data.linkedin,
            contact_name: response.data.data.contact_name,
            download_blurb: response.data.data.download_blurb,
        });
    }

    /**
     * @method handleSubmit
     * @param {object} form
     * @return {Promise<*>}
     */
    handleSubmit = (form) => {
        const {exhibitor_id} = this.state;

        if (exhibitor_id) {
            return AdminExhibitorsApi.patch(exhibitor_id, form);
        } else {
            return AdminExhibitorsApi.post(null, form);
        }
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {exhibitor_id} = this.state;
        const {form, working, alert, handleInput, getFieldError, handleSubmit} = this.props;

        let zones = null;
        if (window.base.exhibitor_zones) {
            zones = window.base.exhibitor_zones.map((zone, key) => {
                return {
                    label: zone,
                    value: zone
                };
            });
        }

        let languages = Object.entries(window.base.languages).map((value, key) => {
            return {
                label: value[1],
                value: value[0]
            };
        });

        return (
            <AdminLayout title={'Admin Exhibitors - ' + (exhibitor_id ? 'Update' : 'Create') + ' Exhibitor'}>
                <form
                    className="divide-y divide-gray-200"
                    onSubmit={(e) => handleSubmit(e, this.handleSubmit, this.success, (exhibitor_id ? false : true))}
                >
                    <div className="mx-6">
                        {alert !== null && (<Alert {...alert} />)}

                        <div className="grid grid-cols-2 gap-4 mb-4 border-0">
                            <div>
                                <Input
                                    label="Name"
                                    value={form.name}
                                    id="name"
                                    error={getFieldError('name')}
                                    onChange={(v) => handleInput('name', v)}
                                />
                            </div>

                            {window.base.exhibitor_zones &&
                                <div>
                                    <Select
                                        label="Zone"
                                        value={form.zone}
                                        error={getFieldError('zone')}
                                        onChange={(v) => handleInput('zone', v)}
                                        options={zones}
                                    />
                                </div>
                            }

                            {languages.length > 1 &&
                                <div>
                                    <Select
                                        label="Supported Languages"
                                        value={form.supported_languages}
                                        error={getFieldError('supported_languages')}
                                        onChange={(v) => handleInput('supported_languages', v)}
                                        options={languages}
                                        isMulti
                                    />
                                </div>
                            }

                            <div>
                                <Input
                                    label="Email"
                                    value={form.email}
                                    id="email"
                                    error={getFieldError('email')}
                                    onChange={(v) => handleInput('email', v)}
                                />
                            </div>

                            <div>
                                <Input
                                    label="Telephone"
                                    value={form.telephone}
                                    id="telephone"
                                    error={getFieldError('telephone')}
                                    onChange={(v) => handleInput('telephone', v)}
                                />
                            </div>

                            <div>
                                <Input
                                    label="Website"
                                    value={form.website}
                                    id="website"
                                    error={getFieldError('website')}
                                    onChange={(v) => handleInput('website', v)}
                                />
                            </div>

                            <div>
                                <Input
                                    label="LinkedIn"
                                    value={form.linkedin}
                                    id="linkedin"
                                    error={getFieldError('linkedin')}
                                    onChange={(v) => handleInput('linkedin', v)}
                                />
                            </div>

                            <div>
                                <Input
                                    label="Contact Name"
                                    value={form.contact_name}
                                    id="contact_name"
                                    error={getFieldError('contact_name')}
                                    onChange={(v) => handleInput('contact_name', v)}
                                />
                            </div>



                            <div>
                                <Toggle
                                    label="Active"
                                    value={form.active}
                                    error={getFieldError('active')}
                                    onChange={v => handleInput('active', v)}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="px-6 pt-6 flex justify-end gap-4">
                        <Link to="/admin/exhibitors">
                            <SecondaryButton type="button" text="Back" />
                        </Link>

                        <PrimaryButton
                            text="Save"
                            working={working}
                        />
                    </div>
                </form>
            </AdminLayout>
        )
    }
}

export default FormHandler(ExhibitorsStore);
